(function () {
  'use strict';

  angular.module('eclipseApp.support').config(['$stateProvider', function ($stateProvider) {
    $stateProvider
      .state('support', {
        url: '/support',
        parent: 'app',
        title: "support",
        data: {
          service: 'support'
        },
        views: {
          content: {
            templateUrl: 'modules/support/views/support.html',
            controller: 'supportCtrl'
          }
        }
      });
  }]);

})();
